import { useState } from 'react'
import type { KeyboardEvent } from 'react'
import { Chip } from '@shared/design-system/ui'
import { benefitsField, benefitsInput } from './product.css'

type PlanBenefitsInputProps = {
  benefits: string[]
  onChange: (next: string[]) => void
  inputId?: string
}

export function PlanBenefitsInput({ benefits, onChange, inputId }: PlanBenefitsInputProps) {
  const [draft, setDraft] = useState('')

  function commitDraft() {
    const value = draft.trim()
    setDraft('')
    if (value.length === 0) return
    if (benefits.some((benefit) => benefit.toLowerCase() === value.toLowerCase())) return
    onChange([...benefits, value])
  }

  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault()
      commitDraft()
      return
    }
    if (event.key === 'Backspace' && draft.length === 0 && benefits.length > 0) {
      onChange(benefits.slice(0, -1))
    }
  }

  return (
    <div className={benefitsField}>
      {benefits.map((benefit, index) => (
        <Chip
          key={`${benefit}:${index}`}
          label={benefit}
          onRemove={() => onChange(benefits.filter((_, position) => position !== index))}
        />
      ))}
      <input
        id={inputId}
        className={benefitsInput}
        value={draft}
        onChange={(event) => setDraft(event.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={commitDraft}
        placeholder={
          benefits.length === 0 ? 'Digite um benefício e tecle Enter' : 'Adicionar benefício'
        }
      />
    </div>
  )
}
